var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSummaryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "summary_icon",
    transform: "translate(-618 -618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23619",
    "data-name": "Path 23619",
    d: "M0,0H18V18H0Z",
    transform: "translate(618 618)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "reports",
    transform: "translate(619.456 618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23611",
    "data-name": "Path 23611",
    d: "M42.087,37.912A1.593,1.593,0,0,1,40.5,39.5H28.587A1.593,1.593,0,0,1,27,37.912V23.088A1.593,1.593,0,0,1,28.587,21.5H40.5a1.593,1.593,0,0,1,1.588,1.588V37.912",
    transform: "translate(-26.999 -21.5)",
    fill: "#dadee0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23613",
    "data-name": "Path 23613",
    d: "M39.9,36.433h7.941a.4.4,0,1,0,0-.794H39.9a.4.4,0,1,0,0,.794m0-2.647h7.941a.4.4,0,1,0,0-.794H39.9a.4.4,0,1,0,0,.794m0,5.294h7.941a.4.4,0,1,0,0-.794H39.9a.4.4,0,1,0,0,.794",
    transform: "translate(-36.192 -22.803)",
    fill: "#a4abb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23623",
    "data-name": "Path 23623",
    d: "M15.077,14.311v-.06h0v-.038a.1.1,0,0,0,0-.045,7.018,7.018,0,0,1-.189-1.747,2.745,2.745,0,0,0-2.556-2.76,2.707,2.707,0,0,0-2.564,2.76,6.723,6.723,0,0,1-.189,1.747v.083h0v.106a.159.159,0,0,0,0,.045v.045h.151a.083.083,0,0,0,.045,0h1.27a1.21,1.21,0,0,0,2.412,0h1.618Zm-2.745-4.1a2.163,2.163,0,0,1,1.989,2.193,8.614,8.614,0,0,0,.113,1.55H10.207a8.478,8.478,0,0,0,.129-1.55A2.133,2.133,0,0,1,12.332,10.212Zm.635,4.318a.643.643,0,0,1-1.278,0h1.278Z",
    transform: "translate(-4.784 -7.582)",
    fill: "#577996"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5744",
    "data-name": "Rectangle 5744",
    width: 1.44,
    height: 0.18,
    transform: "matrix(0.875, 0.485, -0.485, 0.875, 1.304, 1.372)",
    fill: "#8c9faf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5748",
    "data-name": "Rectangle 5748",
    width: 1.44,
    height: 0.18,
    transform: "matrix(-0.875, 0.485, -0.485, -0.875, 13.692, 1.53)",
    fill: "#8c9faf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5745",
    "data-name": "Rectangle 5745",
    width: 1.44,
    height: 0.175,
    transform: "matrix(0.809, -0.588, 0.588, 0.809, 1.296, 6.611)",
    fill: "#8c9faf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5749",
    "data-name": "Rectangle 5749",
    width: 1.44,
    height: 0.18,
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 13.69, 6.75)",
    fill: "#8c9faf"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryIcon);
export default __webpack_public_path__ + "static/media/summary_icon.980299e3350917efea6842ceb0852f53.svg";
export { ForwardRef as ReactComponent };